module.exports = __webpack_public_path__ + "images/bug_purple_large_7d27f369f17f4954dc9751c46dd5f9ad.png";